export const environment = {
  production: false,
  projectName: "KIPOINT TEST",
  REST_API_SERVER: "https://kipoint.test.api.testctsolution.it/api",
  URL_CALLBACK: "https://kipoint.test.fe.testctsolution.it",
  googleMapsApiKey: 'AIzaSyCyXPLM-cdTQ8NeJT9grcXclLJZdNmnv6A'
}
